<template>
	<div id="vue-modal-template" v-if="getModalLogin">
    <transition name="vue-modal">
      <div class="vue-modal-mask" @click="closeModalLogin"><!--  @click.stop.prevent-->
        <div class="vue-modal-wrapper">
					<div class="container container-xs" @click.stop.self.prevent>
						<div class="vue-modal-close">
							<button @click="closeModalLogin" class="btn btn-secondary btn-xs"><i class="fa fa-close"></i></button>
						</div> 

						<div class="vue-modal-content">							
							<div class="row">
								<div class="col-md-12 modal-login">

									<h4>Login</h4>
									<img src="@/assets/img/logo-tatarana.svg" class="logo" alt="">
                  <!-- <br>
                  Sistema cerrado por mantenimiento. <br>
                  Disculpe las molestias
                  <br><br><br><br> -->

									<form method="post" v-on:submit.prevent="onSubmit" v-if=" !getLoggedIn ">
										<div class="form-head fix">
	                    <div class="marg-area">
	                      <input type="text" :placeholder=" $t('Nombre de usuario') " v-model="frm_username" maxlength="80" required ref="username">
	                    </div>
	                    <div class="marg-area">
	                      <input type="password" :placeholder=" $t('Contraseña') " v-model="frm_pwd" maxlength="150" autocomplete="on" required>
	                    </div>
	                  </div>

	                  <div v-if="loading" class="loading"><img src="@/assets/img/loading.gif" alt=""></div>
	                  <div v-if="frm_success" class="frm-success">{{ frm_success_message }}</div>
                  	<div v-if="frm_error" class="frm-error">{{ frm_error_message }}</div>

	                  <button class="btn btn-tata mb30" type="submit" :disabled="loading">Login <i class="fa fa-angle-double-right"></i></button>
	                </form>

	                <div v-else>
	                	<div v-if="frm_success" class="frm-success">{{ frm_success_message }}</div>
                    <div v-if="frm_error" class="frm-error">{{ frm_error_message }}</div>
	                	<button class="btn btn-tata mb30" @click="logout">Logout <i class="fa fa-angle-double-right"></i></button>
	                </div>

                  <div class="comment mb20"> 
                    <router-link @click.native="closeModalLogin" :to=" { name: 'registro', prams: { language: getLocale } } ">{{ $t('Registro') }}</router-link> <span>|</span> 
                    <router-link @click.native="closeModalLogin" :to=" { name: 'restablecer', prams: { language: getLocale } } ">{{ $t('Restablecer contraseña') }}</router-link>
                  </div>
								</div>
							</div>
						</div>

          </div>
        </div>
      </div>
  	</transition>
  </div>
</template>

<i18n>
{
  "es": {
    "Nombre de usuario": "Nombre de usuario",
    "Contraseña": "Contraseña" ,
    "Registro": "Registro",
    "Restablecer contraseña": "Restablecer contraseña"
  },
  "en": {
  
  },
  "ca": {
    "Nombre de usuario": "Nom d'usuari",
    "Contraseña": "Contrasenya",
    "Registro": "Registre",
    "Restablecer contraseña": "Restablir contrasenya"
  }
}
</i18n>

<script>
	import axios from 'axios'; 
	import { mapGetters, mapMutations} from 'vuex';


	export default {
		data: () => {
			return{
				frm_username: '',
        frm_pwd: '',
        frm_response: '',
        frm_success: false,
        frm_success_message: '',
        frm_error: false,
        frm_error_message: '',
        loading: false
			}
		},
	  mounted(){
	  	document.addEventListener("keydown", (e) => {
	      if (this.getModalLogin && e.keyCode == 27) {
	        this.$store.commit('closeModalLogin');
	      }
    	});
	  },
	  computed: mapGetters(['getModalLogin', 'getLoggedIn', 'getToken', 'getLocale', 'getApiUrl', 'getRouteLogin']), 
	  methods: {
	  	...mapMutations(['showModalLogin', 'closeModalLogin', 'setToken', 'setLoggedIn', 'setLoggedOut', 'setReloadContent']),
	  	onSubmit() {
        this.frm_success = false;
        this.frm_error = false;
        this.showLoading();
		
        axios.post( this.getApiUrl + this.getLocale + '/login', {
          nombreUsuario: this.frm_username,
          contrasena: this.frm_pwd
        })
        	.then( (respuesta) =>{ 

            //console.log(respuesta)
            
	          //this.frm_response = respuesta.data.token;
	          this.hideLoading();

	          this.$store.commit('setLoggedIn');
            this.$store.commit('setUsername', respuesta.data.data.nombreUsuario);
            this.$store.commit('setUserHashBrowser', respuesta.data.data.userhash);

            this.frm_success_message = respuesta.data.msg;
            this.frm_success = true;

	          this.clearFormData();

            if(respuesta.data.data.enlace){
              window.location.replace(respuesta.data.data.enlace);
            }else{
              this.$store.commit('setReloadContent', true);
            }

        	})
        .catch( (error) =>{ 
          this.hideLoading();
          //console.log(error);
          //this.frm_error_message = error;
          this.frm_error_message = error.response.data.msg;
          this.frm_error = true;
        });

      },
      logout(){
        axios.get( this.getApiUrl + this.getLocale + '/logout')
        //axios.get('src/json/menu-productos.json')

          .then( (respuesta) =>{ 
            //console.log(respuesta);
            //this.frm_response = respuesta.data.token;
            this.clearFormData();
            this.frm_success = false,
            this.frm_success_message = '',

            this.$store.commit('setLoggedOut');
            this.$store.commit('setUserHashBrowser', 'null');

            this.hideLoading();

            if( this.$route.name != 'catalogo' ){
              this.$router.push({ name: 'catalogo', params: { language: this.getLocale, category: 'indice' } });
            }
          })
        .catch( (error) =>{ 
          this.hideLoading();
          console.log(error);
          //this.frm_error_message = error;
          this.frm_error_message = error.response.data.msg;
          this.frm_error = true;
        });
        //this.$router.push('/'+this.getLocale+'/catalogo/indice');
        
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
      clearFormData(){
      	this.frm_username = '';
        this.frm_pwd = '';
      }
    },
    watch:{
      getModalLogin: function(newValue, oldValue){
        if( newValue == true && this.getLoggedIn == false ){
          this.$nextTick(() => this.$refs.username.focus())
        }
      },
      getRouteLogin: function(newValue, oldValue){
        if( newValue ){
          this.$store.commit('showModalLogin')
        }
      }
    }
	}
</script>
